{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-github-oauth-ui",
  "version": "7.0.0",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^4.1.0",
    "@octokit/request": "^9.2.4",
    "@verdaccio/core": "^6.0.0-6-next.76",
    "@verdaccio/url": "^13.0.0-next-8.28",
    "dotenv": "^16.6.1",
    "express": "^4.22.1",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^3.2.2",
    "open": "^8.4.2",
    "ow": "^0.28.2",
    "picocolors": "^1.1.1",
    "query-string": "^7.1.3"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.25",
    "@types/global-agent": "^2.1.3",
    "@types/lodash": "^4.17.23",
    "@types/memory-cache": "^0.2.6",
    "@types/minimist": "^1.2.5",
    "@types/node": "^20.19.29",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^13.0.0-next-8.10",
    "@vitest/coverage-v8": "^3.2.4",
    "browserslist": "^4.28.1",
    "core-js": "^3.47.0",
    "nodemon": "^3.1.11",
    "parcel": "~2.4.1",
    "prettier": "^3.7.4",
    "process": "^0.11.10",
    "release-it": "^18.1.2",
    "timekeeper": "^2.3.1",
    "type-fest": "^4.41.0",
    "typescript": "^5.9.3",
    "verdaccio": "^6.2.4",
    "verdaccio-htpasswd": "^13.0.0-next-8.28",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "verdaccio": ">=6"
  },
  "packageManager": "yarn@4.8.1",
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-6.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
